define('bizzabo/views/AppView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/consts',
    'bizzabo/config',
    'bizzabo/models/Global',
    'bizzabo/utils',
    'bizzabo/views/LeftPanelView',
    'bizzabo/views/TopPanelView',
    'bizzabo/views/main/EditAgendaView',
    'bizzabo/views/main/PollsView',
    'bizzabo/views/main/DashboardView',
    'bizzabo/views/main/SponsorsView',
    'bizzabo/views/main/CommunityView',
    'bizzabo/views/main/PartnersView',
    'bizzabo/views/EventBriteConnectView',
    'bizzabo/views/EtouchesConnectView',
    'bizzabo/bzapi'
], function($,
            Backbone,
            _,
            Consts,
            CONFIG,
            Global,
            UTILS,
            LeftPanelView,
            TopPanelView,
            EditAgendaView,
            PollsView,
            DashboardView,
            SponsorsView,
            CommunityView,
            PartnersView,
            EventBriteConnectView,
            EtouchesConnectView,
            BZAPI) {

    var AppView = Backbone.View.extend({

        introView: undefined,
        leftPanelView: undefined,
        topPanelView: undefined,
        mainView: undefined,
        pendingMainView: undefined,
        pendingViewPreparationTime: undefined,

        initialize: function() {
            _.bindAll(this, 'putMainViewBack', 'failedToPrepareMainView', 'switchPreparedMainView', 'hideTabLoader', 'selectTab');

            this.introView = new IntroView({
                el: this.$("#intro")
            });
            this.introView.render();

            this.leftPanelView = new LeftPanelView({
                el: this.$('.menu'),
                model: Global.modelPool.getAuth()
            });
            this.leftPanelView.render();

            this.topPanelView = new TopPanelView({
                el: this.$('.topContent')
            });
            this.topPanelView.render();

            this.listenTo(Backbone, Consts.Notifications.mainPage.PREPARE_SUCCESS, this.switchPreparedMainView);
            this.listenTo(Backbone, Consts.Notifications.mainPage.PREPARE_FAILURE, this.failedToPrepareMainView);
            this.listenTo(Backbone, Consts.Notifications.mainPage.SWITCHED, this.checkIfEventSwitched);
            this.listenTo(Backbone, Consts.Notifications.eventBrite.SHOW_CONNECT_VIEW, this.showEventBriteConnect);
            this.listenTo(Backbone, Consts.Notifications.etouches.SHOW_CONNECT_VIEW, this.showEtouchesConnect);
        },

        remove: function() {
            this.introView && this.introView.remove();
            this.leftPanelView && this.leftPanelView.remove();
            this.topPanelView && this.topPanelView.remove();
            this.mainView && this.mainView.remove();
            this.pendingMainView && this.pendingMainView.remove();
            this.pendingViewPreparationTime = undefined;

            this.stopListening();
            this.$el.remove();
            return this;
        },

        /********** incoming flows from router **********/

        main: function() {
            Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, '/event/new', {
                trigger: true,
                replace: true
            });
        },

        editAgenda: function(eventId, deepLinkParams) {
            var agenda = Global.modelPool.getAgenda(eventId);
            var servicePlan = Global.modelPool.getServicePlan(eventId);
            this.showAgenda(agenda, servicePlan, deepLinkParams);
        },

        dashboard: function(eventId) {
            var currentEvent = Global.modelPool.getEvent(eventId);
            this.showDashboard(currentEvent);
        },

        sponsors: function(eventId, deepLinkParams) {
            var currentEvent = Global.modelPool.getEvent(eventId);
            this.showSponsors(currentEvent, deepLinkParams);
        },

        community: function(eventId) {
            var currentEvent = Global.modelPool.getEvent(eventId);
            this.showCommunity(currentEvent);
        },
        partners: function(eventId) {
            var currentEvent = Global.modelPool.getEvent(eventId);
            this.showPartners(currentEvent);
        },

        polls: function(eventId) {
            var currentEvent = Global.modelPool.getEvent(eventId);
            this.showPolls(currentEvent);
        },

        /********** query params methods **********/

        /**
         * Reports params to analytics and clears them
         * @param queryParams the HTTP query parameters (such as ...?p1=a&p2=b)
         */
        applyQueryParams: function(queryParams) {
            if (_.isUndefined(queryParams)) {
                var paramsBefore = window.location.search;
                if (paramsBefore) {
                    queryParams = {};
                    var queryParamsParts = paramsBefore.substr(1).split("&");
                    for (var i = 0; i < queryParamsParts.length; i++) {
                        var queryParam = queryParamsParts[i].split("=");
                        queryParams[queryParam[0]] = (queryParam.length > 1 ? queryParam[1] : undefined);
                    }
                }
                else {
                    return;
                }
            }

            Global.analytics.setCampaignParams(queryParams);
            this.clearQueryParamsFromUrl();
        },

        clearQueryParamsFromUrl: function() {
            var fragment = UTILS.getFragmentSubString(document.URL);
            Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, fragment, {
                trigger: false,
                replace: true
            }); // todo when push-state will be enabled, remove the query params when they appear before the hash as well
        },

        /********** inner methods **********/

        showPolls: function(currentEvent) {
            var thisView = this;
            var newMainView = new PollsView({
                model: currentEvent
            });

            thisView.prepareMainView(newMainView);
        },

        showDashboard: function(currentEvent) {
            var thisView = this;
            var newMainView = new DashboardView({
                model: currentEvent
            });

            thisView.prepareMainView(newMainView)
        },

        showSponsors: function(currentEvent, deepLinkParams) {
            var thisView = this;

            var newMainView = new SponsorsView({
                model: currentEvent,
                deepLinkParams: deepLinkParams
            });

            thisView.prepareMainView(newMainView);
        },

        showCommunity: function(currentEvent) {
            var thisView = this;
            var newMainView = new CommunityView({
                model: currentEvent
            });

            thisView.prepareMainView(newMainView);
        },
        showAgenda: function(agenda, servicePlan, deepLinkParams) {
            var thisView = this;
            var currentEvent = Global.modelPool.getEvent(agenda.get('eventId'));
            if (thisView.mainView &&
                (thisView.mainView.tabClass == Consts.UI.tabClasses.AGENDA) &&
                thisView.mainView.model == agenda
            ) {
                thisView.mainView.applyDeepLink(deepLinkParams);
            }
            else {
                var newMainView = new EditAgendaView({
                    model: agenda,
                    servicePlan: servicePlan,
                    deepLinkParams: deepLinkParams
                });
                thisView.prepareMainView(newMainView);
            }
        },

        showPartners: function(currentEvent) {
            var thisView = this;
            var newMainView = new PartnersView({
                model: currentEvent
            });

            thisView.prepareMainView(newMainView);
        },

        showEventBriteConnect: function() {
            new EventBriteConnectView().show();
        },

        showEtouchesConnect: function() {
            new EtouchesConnectView().show();
        },

        prepareMainView: function(newMainView) {
            this.pendingMainView = newMainView;

            var newTabClass = this.pendingMainView.tabClass;
            var oldTabClass = this.mainView ? this.mainView.tabClass : undefined;
            this.selectTab(newTabClass, oldTabClass);
            this.$('.menu ul li.selected img').css('visibility', 'visible');

            // slightly shift current page right
            if (!_.isUndefined(this.mainView)) {
                this.$('.main').addClass('mainLoading');
                this.$('header.top').addClass('topLoading');
            }

            this.pendingViewPreparationTime = new Date().getMilliseconds();
            this.pendingMainView.prepare();// will eventually generate sync/async call to switchPreparedMainView or to failedToPrepareMainView
        },

        /**
         * on success: replace current main page with new one
         */
        switchPreparedMainView: function() {
            // render new page, remove and replace old one
            var oldMainView = this.mainView;
            oldMainView && oldMainView.remove();
            this.pendingMainView.render();
            this.mainView = this.pendingMainView;
            this.$('.main').html(this.mainView.el);
            UTILS.minDelay(this.pendingViewPreparationTime, Consts.UI.mainView.MAIN_VIEW_SWITCH_MIN_DELAY, this.putMainViewBack);
        },

        /**
         * on failure to prepare main page: show error msg and return previous main page
         */
        failedToPrepareMainView: function() {
            var errorMsg = this.pendingMainView.failedToLoadErrorMsg;
            Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                msg: errorMsg
            });
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category: 'Organizer Responses',
                action: 'Failed to prepare main view'
            });
            UTILS.minDelay(this.pendingViewPreparationTime, Consts.UI.mainView.MAIN_VIEW_SWITCH_MIN_DELAY, this.putMainViewBack);
        },

        putMainViewBack: function() {
            // motion back to the left
            this.$('.main').removeClass('mainLoading');
            this.$('header.top').removeClass('topLoading');

            // hide loader and select tab (if changed)
            var newTabClass = this.pendingMainView.tabClass;
            if (this.mainView) {
                var oldTabClass = this.mainView.tabClass;
                if (newTabClass != oldTabClass) {
                    this.selectTab(newTabClass, oldTabClass);
                }
            }

            this.pendingMainView = undefined;
            this.pendingViewPreparationTime = undefined;

            UTILS.minDelay(new Date().getMilliseconds(), Consts.UI.mainView.TAB_LOADER_HIDE_DELAY, this.hideTabLoader);
            Backbone.trigger(Consts.Notifications.mainPage.SWITCHED);
        },

        selectTab: function(newTabClass, oldTabClass) {
            if (newTabClass === oldTabClass) {
                return;
            }
            if (_.isUndefined(newTabClass)) {
                newTabClass = this.mainView && this.mainView.tabClass;
            }

            if (oldTabClass) {
                this.$('.menu ul li.' + oldTabClass).removeClass('selected');
            }
            if (newTabClass) {
                this.$('.menu ul li.' + newTabClass).addClass('selected');
            }
        },

        hideTabLoader: function() {
            this.$('.menu ul li.selected img').css('visibility', 'hidden');
        },

        checkIfEventSwitched: function() {
            var oldActiveEvent = Global.modelPool.getActiveEvent();
            var newActiveEvent = this.mainView.model;
            var notification;
            switch (this.mainView.tabClass) {
                case Consts.UI.tabClasses.INFORMATION:
                    notification = Consts.Notifications.mainPage.INFO_PAGE_LOADED;
                    break;
                case Consts.UI.tabClasses.AGENDA:
                    var newActiveEventId = this.mainView.model.get('eventId');
                    var modelPool = Global.modelPool;
                    newActiveEvent = newActiveEventId == 'new' ? modelPool.getEventDraft() : modelPool.getEvent(newActiveEventId);
                    notification = Consts.Notifications.mainPage.AGENDA_PAGE_LOADED;
                    break;
                case Consts.UI.tabClasses.DASHBOARD:
                    notification = Consts.Notifications.mainPage.DASHBOARD_PAGE_LOADED;
                    break;
                case Consts.UI.tabClasses.SPONSORS:
                    notification = Consts.Notifications.mainPage.SPONSORS_PAGE_LOADED;
                    break;
                case Consts.UI.tabClasses.PARTNERS:
                    notification = Consts.Notifications.mainPage.PARTNERS_PAGE_LOADED;
                    break;
                case Consts.UI.tabClasses.COMMUNITY:
                    notification = Consts.Notifications.mainPage.COMMUNITY_PAGE_LOADED;
                    break;
                case Consts.UI.tabClasses.SERVICE_PLAN:
                    notification = Consts.Notifications.mainPage.SERVICE_PLAN_PAGE_LOADED;
                    break;
                case Consts.UI.tabClasses.POLLS:
                    notification = Consts.Notifications.mainPage.POLLS_PAGE_LOADED;
                    break;
                default:
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg: "Something went wrong. Please reload the page."
                    });
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category: 'Organizer Responses',
                        action: 'Failed to switch main view'
                    });
            }
            if (newActiveEvent != oldActiveEvent) {
                Global.modelPool.setActiveEvent(newActiveEvent);
                Backbone.trigger(Consts.Notifications.activeEvent.SWITCHED, {
                    oldActiveEvent: oldActiveEvent,
                    newActiveEvent: newActiveEvent
                });
            }
            if (notification) {
                Backbone.trigger(notification);
            }
            if (!this.mainView.letMeRemoveIntro) {
                this.introView.remove();
            }
        }
    });

    var IntroView = Backbone.View.extend({

        delayBetweenFrames: 70,
        numberOfFrames: 20,
        currentFrame: 0,
        singleFrameHeight: 78,
        isPlaying: true,

        render: function() {
            _.bindAll(this, 'playPngSequence');
            this.playPngSequence();
            return this;
        },

        remove: function() {
            this.isPlaying = false;
            this.$el.remove();
            Global.appView.$el.removeClass("noScrolls");
            return this;
        },

        playPngSequence: function() {
            if (!this.isPlaying) {
                return;
            }

            this.currentFrame++;
            if (this.currentFrame >= this.numberOfFrames) {
                this.currentFrame = 0;
            }
            var top = this.currentFrame * this.singleFrameHeight;
            this.$(".sequence").css("background-position", "0 -" + top + "px");

            _.delay(this.playPngSequence, this.delayBetweenFrames);
        }
    });

    return AppView;
});

